import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent } from '@/components/Card'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import { bpcActualsSearchSchema, useCreateBpcActuals } from '@/hooks/queries/crt/useBpcActuals'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import BpcActualsDataTable from './-components/BpcActualsDataTable'
import { CreateBpcActualsDialog } from './-components/CreateBpcActualsDialog'

export const Route = createFileRoute('/_auth/_modules/crt/bpc-actuals/')({
  component: RouteComponent,
  validateSearch: (search) => bpcActualsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateBpcActuals({
    queries: search,
    handleOnSuccess: () => setIsOpen(false),
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('bpcActuals.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_bpc_actuals_create']}>
          <CreateBpcActualsDialog
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            isPending={isPending}
            onSubmit={({ name, description, year }) => mutate({ name, description, year })}
          />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardContent className="pt-6">
          <VStack gap="md">
            <BpcActualsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
